import { useEffect, useRef, useState } from "react";
import { TPaymentRow } from "../../../../services/backoffice/backoffice-service";
import { useRouteNavigation } from "../../../../lib/common/routes";

type PaymentRecordMenuProps = {
    recordRowData: TPaymentRow;
    onCloseMenu: () => void;
    retryPaymentCallback: (user_id: number) => void;
};

export const PaymentRecordMenu = ({
    recordRowData,
    onCloseMenu,
    retryPaymentCallback,
}: PaymentRecordMenuProps) => {
    const { navigateToRoute } = useRouteNavigation();
    const isDisabled = recordRowData.state !== "failed";
    const refRetryPaymentModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;
    const [showFirstModal, setShowFirstModal] = useState(false);

    const handleFirstModalShow = () => {
        setShowFirstModal(true);

        const showModal1 = () => {
            if (!refRetryPaymentModal.current) {
                setTimeout(() => {
                    showModal1();
                }, 100);
                return;
            }

            windowGlobal.wwg_refRetryPaymentModal = new window.bootstrap.Modal(
                refRetryPaymentModal.current
            );

            if (windowGlobal.wwg_refRetryPaymentModal) {
                windowGlobal.wwg_refRetryPaymentModal.show();
            }
        };

        showModal1();
    };

    const handleFirstModalClose = () => {
        onCloseMenu();
        if (!refRetryPaymentModal.current) {
            setTimeout(() => {
                handleFirstModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_refRetryPaymentModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refRetryPaymentModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_refRetryPaymentModal.hide();
        }
        setShowFirstModal(false);
    };

    useEffect(() => {
        return () => {
            if (windowGlobal.wwg_refRetryPaymentModal) {
                windowGlobal.wwg_refRetryPaymentModal.hide();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="dropdown-menu show actionsMenu">
                <button
                    className="dropdown-item"
                    onClick={(e) => {
                        e.stopPropagation();
                        onCloseMenu();
                        navigateToRoute(
                            "adminUserInfoLab",
                            recordRowData.user_id.toString(),
                            true
                        );
                    }}
                >
                    <i className="fa-solid fa-user me-2 fa-xs"></i>
                    <small>View Profile</small>
                </button>
                <button
                    className={`dropdown-item btn text-primary btn-primary  ${
                        !isDisabled ? "fw-bold" : ""
                    }`}
                    onClick={() => handleFirstModalShow()}
                    disabled={isDisabled}
                    type="button"
                    data-bs-target="retryPaymentModal"
                >
                    <i className="fa-solid fa-repeat me-2 fa-xs"></i>
                    <small>Retry Payment</small>
                </button>
                {/* <button
                className="dropdown-item text-danger"
                onClick={(e) => {
                    e.stopPropagation();
                    onCloseMenu();
                    }}
                    >
                    <i className="fa-solid fa-ban me-2 fa-xs"></i>
                    <small>Block User</small>
                    </button> */}
            </div>

            {/* Retry Payment Intent Modal */}
            {showFirstModal && (
                <div
                    className="modal fade"
                    tabIndex={-1}
                    ref={refRetryPaymentModal}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title fw-bold ">
                                    ⚠️ WARNING ⚠️
                                </h3>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    data-bs-dismiss="modal"
                                    onClick={handleFirstModalClose}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    {" "}
                                    <strong>
                                        You are about to manually retry a
                                        payment for{" "}
                                        <span className="text-primary">
                                            {recordRowData.name}
                                        </span>
                                        .
                                    </strong>
                                </p>
                                <hr />
                                <ul>
                                    <li>
                                        If you proceed, the system will attempt
                                        to charge this user's card again.{" "}
                                    </li>
                                    <li>
                                        If this is done by mistake, you might
                                        incorrectly bill the user, leading to
                                        disputes, chargebacks, and potential
                                        platform issues.
                                    </li>
                                </ul>
                                ⚠️ Make sure this is 100% necessary before
                                continuing.
                            </div>
                            <div className="modal-footer">
                                <strong>
                                    Do you really want to proceed with this
                                    manual payment attempt?
                                </strong>
                                <button
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                        handleFirstModalClose();
                                    }}
                                >
                                    No, cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        retryPaymentCallback(
                                            recordRowData.user_id
                                        );
                                    }}
                                >
                                    Yes, proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

type TPaymentRecordRowProps = {
    recordRow: TPaymentRow;
    retryPaymentCallback: (user_id: number) => void;
};
export const PaymentRecordRow = (props: TPaymentRecordRowProps) => {
    const { recordRow, retryPaymentCallback } = props;
    const [menuOpen, setMenuOpen] = useState(false);
    const menuButtonRef = useRef<HTMLTableCellElement>(null);

    const closeMenu = () => {
        setMenuOpen(false);
        document.removeEventListener("mousedown", handleClickOutside);
    };

    const openMenu = () => {
        setMenuOpen(true);
        document.addEventListener("mousedown", handleClickOutside);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (
            menuButtonRef.current &&
            !menuButtonRef.current.contains(event.target as Node)
        ) {
            closeMenu();
        }
    };

    const handleMenuClickOpen = () => {
        let currMenuOpenValue = menuOpen;
        setMenuOpen((prev) => {
            currMenuOpenValue = !prev;
            return !prev;
        });
        if (currMenuOpenValue) {
            openMenu();
        }
        if (!currMenuOpenValue) {
            closeMenu();
        }
    };

    useEffect(() => {
        return () => {
            closeMenu();
        };
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <tr className="table-light align-middle">
                <th scope="row">{recordRow.name}</th>
                <td className="text-end">
                    ${parseFloat(recordRow.amount).toFixed(2)}
                </td>

                <td>
                    <div>
                        <p className="mb-1">
                            <span className="badge bg-primary text-uppercase me-2">
                                {recordRow.payment_method?.brand}
                            </span>{" "}
                            <span>•••• {recordRow.payment_method?.last4}</span>
                        </p>
                        <small className="text-muted m-0">
                            Exp: {recordRow.payment_method?.exp_month}/
                            {recordRow.payment_method?.exp_year}
                        </small>
                    </div>
                </td>

                <td style={{ fontSize: "small" }}>
                    {new Date(recordRow.creation_date).toLocaleDateString(
                        "en-US",
                        {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                        }
                    )}
                </td>

                <td style={{ fontSize: "small" }}>{recordRow.concept}</td>

                <td>
                    <span
                        className={`badge ${
                            recordRow.state === "success"
                                ? "bg-success"
                                : "bg-danger"
                        } text-capitalize`}
                    >
                        {recordRow.state}
                    </span>
                </td>
                <td className="position-relative" ref={menuButtonRef}>
                    <button
                        className="btn btn-sm btn-light rounded-circle"
                        onClick={handleMenuClickOpen}
                    >
                        <i className="fa-solid fa-ellipsis"></i>
                    </button>

                    {menuOpen && (
                        <PaymentRecordMenu
                            recordRowData={recordRow}
                            onCloseMenu={() => {
                                setMenuOpen(false);
                            }}
                            retryPaymentCallback={retryPaymentCallback}
                        />
                    )}
                </td>
            </tr>
        </>
    );
};
type TPaymentRecordsListProps = {
    paymentList: TPaymentRow[];
    retryPaymentCallback: (user_id: number) => void;
};
export const PaymentRecordList = ({
    paymentList,
    retryPaymentCallback,
}: TPaymentRecordsListProps) => {
    return (
        <div className="table-responsive rounded-3 pb-lg-5">
            <table className="table table-striped-columns table-hover table-bordered">
                <thead className="table-dark align-middle">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Payment Method</th>
                        <th scope="col">Start Date</th>
                        <th scope="col">Concept</th>
                        <th scope="col">State</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    {paymentList.map((recordRow) => (
                        <PaymentRecordRow
                            recordRow={recordRow}
                            retryPaymentCallback={retryPaymentCallback}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};
